module.exports = __webpack_public_path__ + "assets/img/2b75-ph.svg";